import { FaShare } from "react-icons/fa";
import useSbConfig from "../../Shared/useSbConfig";
import { stringToBase64 } from "../../../utils";
import ActionButton from "../../Shared/ActionButton";

export default ({
  orderEx
}) => {
  const {
    dataSb: {
      id
    },
  } = orderEx

  const sbConfig = useSbConfig()

  const viewShipment = async () => {
    // Example: eJyrVkrLzClJLSpWslJSNXdSNTIqTk0sSs4ISa0oAXJUjR0homWJOaWpUAEjIyNjQ1MLSzMTkICRM5DML0gtSizJL4KrSC0EMc1dgEhJR6m0OLXIM0XJysjCwsjEohYAglwfZQ==
    const pageState = await stringToBase64(JSON.stringify({
      filters: encodeURIComponent(JSON.stringify({
        searchText: {
          value: `${id}`,
          operator: "eq"
        }
      })),
      userId: 288248
    }))
    // 1.0 Didn't exist
    // 2.0 Encoded string (meaning, we really shouldn't do this, but it is technically possible)
    // ${sbConfig.merchantUrl}/App/merchant/#/order-shipment-management/orders?page-state=${pageStateBase64Json}
    window.open(`${sbConfig.merchantUrl}/App/merchant/#/order-shipment-management/orders?page-state=${pageState}`)
  }

  return (
    <ActionButton onClick={viewShipment}>
      <FaShare style={{ paddingRight: '10px' }} />
      View
    </ActionButton>
  )
}
